import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=2be60ee8&scoped=true"
import script from "./SidebarContent.vue?vue&type=script&lang=js"
export * from "./SidebarContent.vue?vue&type=script&lang=js"
import style0 from "./SidebarContent.vue?vue&type=style&index=0&id=2be60ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be60ee8",
  null
  
)

export default component.exports